import { Component, ViewChild, ViewContainerRef, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';

import { IAfterGuiAttachedParams, IDoesFilterPassParams, IFilterParams, RowNode } from 'ag-grid-community';
import { IFilterAngularComp } from 'ag-grid-angular';
import { FilterOptions } from './datagrid.component';
import { FormGroup, FormControl, FormControlName } from '@angular/forms';
import { FormItem } from '../form/FormItem';
import { FieldTypes } from '../../FieldTypes';


@Component({
  selector: 'vias-filter-cell',
  template: `<form #filterForm>
  <div
      #flatpickrEl
      class="ag-input-wrapper custom-date-filter"
      role="presentation"
    >aaaaa
      <input type="text" #eInput data-input style="width: 100%;" />
      <a class="input-button" title="clear" data-clear>
        <i class="fa fa-times"></i>
      </a>
    </div>
</form>`,
  styles: [`
.custom-date-filter a {
  position: absolute;
  right: 20px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
}

.custom-date-filter:after {
  position: absolute;
  content: '\f073';
  display: block;
  font-weight: 400;
  font-family: 'Font Awesome 5 Free';
  right: 5px;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.54);
}
  `,
  ],
  // content: '\f073'; 
})
export class DgFilterComponent {

  @ViewChild('flatpickrEl', { read: ElementRef }) flatpickrEl: ElementRef;
  @ViewChild('eInput', { read: ElementRef }) eInput: ElementRef;
  private date: Date;
  private params: any;
  private picker: any;

  agInit(params: any): void {
    this.params = params;
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
    console.log(`Destroying DateComponent`);
  }

  onDateChanged(selectedDates): void {
    this.date = selectedDates[0] || null;
    this.params.onDateChanged();
  }

  getDate(): Date {
    return this.date;
  }

  setDate(date: Date): void {
    this.date = date || null;
    this.picker.setDate(date);
  }

  setInputPlaceholder(placeholder: string): void {
    this.eInput.nativeElement.setAttribute('placeholder', placeholder);
  }

  setInputAriaLabel(label: string): void {
    this.eInput.nativeElement.setAttribute('aria-label', label);
  }
}
